module.exports = __webpack_public_path__ + "img/ACT.6d7433fc.png";